import request from '@/utils/request'

/**
 * 获取订单列表
 * @param {Object} params 查询参数
 * @returns {Promise} 订单列表数据
 */
export function getOrderList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryUserStoreOrderCart',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 催发货
 * @param {Object} data 请求数据
 * @returns {Promise} 操作结果
 */
export function expeditingDelivery(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder/expeditingDelivery',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 关闭订单
 * @param {Object} data 请求数据
 * @returns {Promise} 操作结果
 */
export function closeOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.closeStoreOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 确认收货
 * @param {Object} data 请求数据
 * @returns {Promise} 操作结果
 */
export function confirmOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder/receiveStoreOrderCart',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取物流信息
 * @param {Object} params 查询参数
 * @returns {Promise} 物流信息
 */
export function getLogisticDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryLogisticsDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 提交评价
 * @param {Object} data 评价数据
 * @returns {Promise} 操作结果
 */
export function submitEvaluate(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopAppraise/saveShopAppraise',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 提交退货
 * @param {Object} data 退货数据
 * @returns {Promise} 操作结果
 */
export function submitReturn(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderCartReturn.saveStoreOrderCartReturn',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}